// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Base layout ===== */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.approver-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
  background: #f8f9fa;
}

.app-topbar {
  height: 64px;
  margin-top: -5px;
  padding-right: 20px;
  padding-left: 20px;
  border-bottom: 1px solid #dbdbdb;
  flex-shrink: 0;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.approver-container {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 18px;
  padding: 24px 28px;
  overflow: hidden;
}


/* ===== Page header ===== */

.am-header-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  flex-shrink: 0;
}

.am-header-left {
  justify-self: start;
}

.am-header-centre {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.am-header-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.main-header {
  margin: 0 0 2px;
  color: #141414;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.am-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.page-error {
  padding: 10px 14px;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}


/* ===== Table container ===== */

.approver-table-container {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}

.approver-table-container.table-loading {
  pointer-events: none;
}

.approver-table-container mc-table {
  display: block;
  width: 100%;
}

.approver-table-container mc-table::part(table-wrapper) {
  width: 100%;
  max-height: calc(70vh - 60px);
  overflow-x: auto;
  overflow-y: auto;
}

.approver-table-container mc-table::part(table) {
  width: max-content;
  min-width: max-content;
}

.approver-table-container mc-table::part(header) {
  position: sticky;
  z-index: 10;
  top: 0;
  border-bottom: 2px solid #e0e0e0;
  background: #f5f5f5;
}

.approver-table-container mc-table::part(row) {
  height: 52px;
}

.approver-table-container mc-table::part(cell) {
  padding: 10px 16px;
  font-size: 14px;
  line-height: 1.5;
}

.approver-table-container mc-table::part(header-cell) {
  padding: 12px 16px;
  color: #141414;
  font-size: 13px;
  font-weight: 600;
}


/* ===== Table action buttons ===== */

.matrix-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border: 1px solid #00243d;
  border-radius: 4px;
  background: #ffffff;
  color: #00243d;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: background 0.15s, color 0.15s;
}

.matrix-edit-btn:hover {
  background: #00243d;
  color: #ffffff;
}

.matrix-delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: #9aabb8;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.matrix-delete-btn:hover {
  border-color: #e53935;
  background: #fff0f0;
  color: #c62828;
}


/* ===== Loader ===== */

.table-loader-overlay {
  position: absolute;
  z-index: 100;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(248, 250, 252, 0.82);
  backdrop-filter: blur(2px);
}

.table-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 28px 36px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.am-loader {
  width: 36px;
  height: 36px;
  border: 3px solid #dbeafe;
  border-top-color: #0073cf;
  border-radius: 50%;
  animation: am-spin 0.9s linear infinite;
}

@keyframes am-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

.no-records {
  padding: 48px;
  color: #94a3b8;
  font-size: 14px;
  text-align: center;
}


/* ===== Pagination ===== */

.pagination-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.pagination-stats {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.results-count {
  color: #1a1a1a;
  font-size: 15px;
  font-weight: 600;
}

.page-info {
  color: #6b7280;
  font-size: 12px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.am-prev-next {
  display: flex;
  align-items: center;
  gap: 8px;
}

.am-page-label {
  font-size: 13px;
  color: #374151;
  white-space: nowrap;
}


/* ===== Drawer backdrop ===== */

.drawer-backdrop {
  position: fixed;
  z-index: 8999;
  inset: 0;
  background: rgba(0, 0, 0, 0);
  pointer-events: none;
  transition: background 0.3s ease;
}

.drawer-backdrop.backdrop-visible {
  background: rgba(0, 0, 0, 0.38);
  pointer-events: all;
}


/* ===== Edit drawer ===== */

.edit-drawer {
  position: fixed;
  z-index: 9000;
  top: 0;
  right: 0;
  display: flex;
  width: 460px;
  max-width: 95vw;
  height: 100vh;
  flex-direction: column;
  background: #ffffff;
  box-shadow: -6px 0 32px rgba(0, 0, 0, 0.14);
  transform: translateX(100%);
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.edit-drawer.drawer-open {
  transform: translateX(0);
}


/* ===== Drawer header ===== */

.drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.drawer-title {
  color: #141414;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.drawer-subtitle {
  margin-top: 3px;
  color: #64748b;
  font-size: 13px;
}

.drawer-close-btn {
  flex-shrink: 0;
  margin-left: 8px;
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  transition:
    color 0.15s,
    background 0.15s;
}

.drawer-close-btn:hover:not(:disabled) {
  background: #f1f5f9;
  color: #141414;
}

.drawer-close-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}


/* ===== Drawer body ===== */

.drawer-body {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
  overflow-y: auto;
}

.drawer-info-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
}

/* ===== Add form ===== */
.add-form-card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid #dde3ea;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 36, 61, 0.08);
}

.add-form-section-title {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #00243d;
}

.add-form-divider {
  border: none;
  border-top: 1px solid #e8ecf0;
  margin: 2px 0;
}

.add-form-field {
  display: flex;
  flex-direction: column;
}

.drawer-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  gap: 8px;
  padding: 2px 0;
}

.drawer-info-row.row-editing {
  align-items: center;
}

.info-label {
  flex-shrink: 0;
  min-width: 130px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.info-value-group {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  gap: 6px;
}

.info-value {
  flex: 1 1;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.info-value.value-changed {
  color: #0073cf;
  font-weight: 600;
}

.changed-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 5px;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  vertical-align: middle;
}


/* ===== Pencil button ===== */

.pencil-btn {
  flex-shrink: 0;
  padding: 2px 4px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  transition:
    color 0.15s,
    background 0.15s,
    border-color 0.15s;
}

.pencil-btn:hover {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #0073cf;
}


/* ===== Inline editing ===== */

.inline-edit-group {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.inline-field-input {
  flex: 1 1;
  max-width: 220px;
  padding: 6px 8px;
  border: 1.5px solid #0073cf;
  border-radius: 4px;
  outline: none;
  background: #ffffff;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 13px;
  box-shadow:
    0 0 0 3px rgba(0, 115, 207, 0.12);
}

.inline-field-input:focus {
  border-color: #005ba4;
}

.inline-done-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  background: #0073cf;
  color: #ffffff;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.15s;
}

.inline-done-btn:hover {
  background: #005ba4;
}


/* ===== Messages ===== */

.drawer-error {
  padding: 10px 14px;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
}

.drawer-success {
  padding: 10px 14px;
  border: 1px solid #86efac;
  border-radius: 6px;
  background: #f0fdf4;
  color: #15803d;
  font-size: 13px;
}


/* ===== Drawer footer ===== */

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}


/* ===== History button ===== */

.matrix-history-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: #64a2c8;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.matrix-history-btn:hover {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: #0073cf;
}



/* ===== History table ===== */

.history-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 0;
}

.history-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  color: #94a3b8;
  font-size: 14px;
  text-align: center;
}

.history-empty p {
  margin: 0;
}


.history-table-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 400px;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.history-table thead tr {
  background: #f5f7fa;
  border-bottom: 2px solid #e0e4ea;
}

.history-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.history-table th {
  padding: 10px 14px;
  color: #374151;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap;
}

.history-table tbody tr {
  border-bottom: 1px solid #f1f4f8;
  transition: background 0.1s;
}

.history-table tbody tr:last-child {
  border-bottom: none;
}

.history-table tbody tr:hover {
  background: #f8fafc;
}

.history-table td {
  padding: 10px 14px;
  vertical-align: middle;
  color: #1a1a1a;
}

.history-td-num {
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  width: 32px;
}

.history-td-old {
  color: #b91c1c;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-td-new {
  color: #15803d;
  font-weight: 600;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-td-by {
  color: #374151;
  white-space: nowrap;
}

.history-td-dt {
  color: #64748b;
  white-space: nowrap;
  font-size: 12px;
}

.history-empty-val {
  color: #94a3b8;
  font-style: italic;
  font-weight: 400;
}

.history-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 4px 4px;
  gap: 12px;
  flex-wrap: wrap;
}

.history-page-info {
  color: #64748b;
  font-size: 13px;
}

.history-page-btns {
  display: flex;
  gap: 8px;
}

.history-page-btn {
  padding: 5px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #ffffff;
  color: #374151;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.15s, border-color 0.15s;
}

.history-page-btn:hover:not(:disabled) {
  border-color: #0073cf;
  background: #eff6ff;
  color: #0073cf;
}

.history-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.history-type-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.history-type-badge.individual {
  background: #dcfce7;
  color: #15803d;
}

.history-type-badge.bulk {
  background: #fef9c3;
  color: #854d0e;
}

.history-field-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: capitalize;
}

.cancel-changes-btn,
.save-changes-btn,
.delete-confirm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
}

.cancel-changes-btn {
  border: 1px solid #9ca3af;
  background: #ffffff;
  color: #1f2937;
}

.cancel-changes-btn:hover:not(:disabled) {
  background: #f3f4f6;
}

.save-changes-btn {
  border: 1px solid #0073cf;
  background: #0073cf;
  color: #ffffff;
}

.save-changes-btn:hover:not(:disabled) {
  border-color: #005ba4;
  background: #005ba4;
}

.delete-confirm-btn {
  border: 1px solid #c62828;
  background: #c62828;
  color: #ffffff;
}

.delete-confirm-btn:hover:not(:disabled) {
  border-color: #991b1b;
  background: #991b1b;
}

.cancel-changes-btn:focus,
.save-changes-btn:focus,
.delete-confirm-btn:focus {
  outline: 2px solid #0073cf;
  outline-offset: 2px;
}

.cancel-changes-btn:disabled,
.save-changes-btn:disabled,
.delete-confirm-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}


/* ===== Delete dialog ===== */

.delete-overlay {
  position: fixed;
  z-index: 9100;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.45);
}

.delete-dialog {
  display: flex;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 28px 24px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.25);
  text-align: center;
}

.delete-dialog-icon {
  margin-bottom: 4px;
  line-height: 1;
}

.delete-dialog-title {
  color: #141414;
  font-size: 17px;
  font-weight: 700;
}

.delete-dialog-msg {
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.delete-dialog-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 8px;
}

.delete-error {
  width: 100%;
  margin-top: 8px;
}


/* ===== Responsive layout ===== */

@media (max-width: 768px) {
  .content-wrapper {
    padding: 18px 14px;
  }

  .pagination-section {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .pagination-controls {
    width: 100%;
    flex-wrap: wrap;
  }

  .edit-drawer {
    width: 100%;
    max-width: 100vw;
  }

  .drawer-header,
  .drawer-body,
  .drawer-footer {
    padding-right: 16px;
    padding-left: 16px;
  }

  .drawer-info-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .info-label {
    min-width: 0;
  }

  .info-value-group,
  .inline-edit-group {
    width: 100%;
  }

  .info-value {
    text-align: left;
  }

  .inline-field-input {
    max-width: none;
  }
}


/* ===== Search bar ===== */

.am-search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 10px;
}

.am-search-badge {
  padding: 4px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
}

.am-search-badge-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.am-search-error {
  color: #b91c1c;
  font-weight: 600;
}


/* ===== Select-all row ===== */

.am-select-all-row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 16px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
}

.am-select-all-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #374151;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}

.am-select-all-label input[type="checkbox"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #0073cf;
}

.am-selected-count {
  padding: 2px 10px;
  border-radius: 12px;
  background: #0073cf;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
}


/* ===== Row checkbox in table ===== */

.row-checkbox {
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #0073cf;
  vertical-align: middle;
}


/* ===== Bulk update result summary ===== */

.bulk-result-summary {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 8px;
  padding: 14px 18px;
  border: 1px solid #86efac;
  border-radius: 8px;
  background: #f0fdf4;
}

.bulk-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bulk-result-title {
  color: #15803d;
  font-size: 14px;
  font-weight: 700;
}

.bulk-result-dismiss {
  padding: 0 4px;
  border: none;
  border-radius: 4px;
  background: none;
  color: #6b7280;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: color 0.15s;
}

.bulk-result-dismiss:hover {
  color: #111827;
}

.bulk-result-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bulk-count {
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
}

.bulk-count.success {
  background: #bbf7d0;
  color: #14532d;
}

.bulk-count.error {
  background: #fecaca;
  color: #7f1d1d;
}

.bulk-count.skipped {
  background: #fef9c3;
  color: #713f12;
}

.bulk-result-row {
  padding: 4px 0;
  border-top: 1px solid #d1fae5;
  color: #374151;
  font-size: 13px;
}

.bulk-row-status {
  display: inline-block;
  margin-right: 8px;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.bulk-row-status.error {
  background: #fecaca;
  color: #7f1d1d;
}

.bulk-row-status.skipped {
  background: #fef9c3;
  color: #713f12;
}


/* ===== Bulk edit drawer body ===== */

.bulk-edit-hint {
  margin: 0 0 4px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.55;
}

.bulk-field-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bulk-field-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  transition: border-color 0.15s, background 0.15s;
}

.bulk-field-item:has(input[type="checkbox"]:checked) {
  border-color: #93c5fd;
  background: #eff6ff;
}

.bulk-field-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.bulk-field-toggle input[type="checkbox"] {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #0073cf;
}

.bulk-field-label {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
}

.bulk-field-input {
  width: 100%;
  padding: 7px 10px;
  border: 1.5px solid #0073cf;
  border-radius: 4px;
  outline: none;
  background: #ffffff;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 13px;
  box-shadow: 0 0 0 3px rgba(0, 115, 207, 0.1);
  transition: border-color 0.15s;
}

.bulk-field-input:focus {
  border-color: #005ba4;
  box-shadow: 0 0 0 3px rgba(0, 115, 207, 0.2);
}


/* ===== Bulk edit — current value hint ===== */

.bulk-current-value {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #f1f5f9;
  font-size: 12px;
  line-height: 1.5;
}

.bulk-current-prefix {
  flex-shrink: 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.bulk-current-text {
  color: #1a1a1a;
  font-weight: 600;
  word-break: break-word;
}

.bulk-current-text em {
  color: #94a3b8;
  font-style: normal;
}

.bulk-current-select {
  flex: 1 1;
  min-width: 0;
  height: 28px;
  padding: 0 6px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  background: #ffffff;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 500;
  cursor: default;
  outline: none;
  appearance: auto;
}

.bulk-current-select:disabled {
  background: #f8fafc;
  color: #334155;
  border-color: #e2e8f0;
  opacity: 1;
}

.bulk-varies-badge {
  flex-shrink: 0;
  padding: 1px 7px;
  border-radius: 10px;
  background: #fef3c7;
  color: #92400e;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border: 1px solid #fcd34d;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Approver/Approvermatrix.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA,4BAA4B;;AAE5B;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;;AAGA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA,qCAAqC;;AAErC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,uBAAuB;;AAEvB;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;;AAGA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;;AAGA,gCAAgC;;AAEhC;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;;AAGA,4BAA4B;;AAE5B;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B;+CAC6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd;;oBAEkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;;AAGA,4BAA4B;;AAE5B;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;;AAGA,8BAA8B;;AAE9B;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd;;;sBAGoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,+BAA+B;;AAE/B;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf;qCACmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,yBAAyB;;AAEzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;;AAGA,8BAA8B;;AAE9B;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;;AAGA,+BAA+B;;AAE/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;;AAGA,8BAA8B;;AAE9B;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB;mCACiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;;AAGA,kCAAkC;;AAElC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA,+BAA+B;;AAE/B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA,sCAAsC;;AAEtC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;;AAGA,2CAA2C;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,sCAAsC;;AAEtC;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;;AAGA,+CAA+C;;AAE/C;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":["/* ===== Base layout ===== */\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n}\n\n.approver-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow: hidden;\n  background: #f8f9fa;\n}\n\n.app-topbar {\n  height: 64px;\n  margin-top: -5px;\n  padding-right: 20px;\n  padding-left: 20px;\n  border-bottom: 1px solid #dbdbdb;\n  flex-shrink: 0;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.approver-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.content-wrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 18px;\n  padding: 24px 28px;\n  overflow: hidden;\n}\n\n\n/* ===== Page header ===== */\n\n.am-header-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.am-header-left {\n  justify-self: start;\n}\n\n.am-header-centre {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.am-header-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.main-header {\n  margin: 0 0 2px;\n  color: #141414;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n}\n\n.am-subtitle {\n  margin: 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.page-error {\n  padding: 10px 14px;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n\n/* ===== Table container ===== */\n\n.approver-table-container {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n}\n\n.approver-table-container.table-loading {\n  pointer-events: none;\n}\n\n.approver-table-container mc-table {\n  display: block;\n  width: 100%;\n}\n\n.approver-table-container mc-table::part(table-wrapper) {\n  width: 100%;\n  max-height: calc(70vh - 60px);\n  overflow-x: auto;\n  overflow-y: auto;\n}\n\n.approver-table-container mc-table::part(table) {\n  width: max-content;\n  min-width: max-content;\n}\n\n.approver-table-container mc-table::part(header) {\n  position: sticky;\n  z-index: 10;\n  top: 0;\n  border-bottom: 2px solid #e0e0e0;\n  background: #f5f5f5;\n}\n\n.approver-table-container mc-table::part(row) {\n  height: 52px;\n}\n\n.approver-table-container mc-table::part(cell) {\n  padding: 10px 16px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.approver-table-container mc-table::part(header-cell) {\n  padding: 12px 16px;\n  color: #141414;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n\n/* ===== Table action buttons ===== */\n\n.matrix-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 28px;\n  padding: 0 12px;\n  border: 1px solid #00243d;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #00243d;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  transition: background 0.15s, color 0.15s;\n}\n\n.matrix-edit-btn:hover {\n  background: #00243d;\n  color: #ffffff;\n}\n\n.matrix-delete-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: #9aabb8;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.matrix-delete-btn:hover {\n  border-color: #e53935;\n  background: #fff0f0;\n  color: #c62828;\n}\n\n\n/* ===== Loader ===== */\n\n.table-loader-overlay {\n  position: absolute;\n  z-index: 100;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: rgba(248, 250, 252, 0.82);\n  backdrop-filter: blur(2px);\n}\n\n.table-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 36px;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.am-loader {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #dbeafe;\n  border-top-color: #0073cf;\n  border-radius: 50%;\n  animation: am-spin 0.9s linear infinite;\n}\n\n@keyframes am-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-text {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.no-records {\n  padding: 48px;\n  color: #94a3b8;\n  font-size: 14px;\n  text-align: center;\n}\n\n\n/* ===== Pagination ===== */\n\n.pagination-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding-top: 12px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.pagination-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.results-count {\n  color: #1a1a1a;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.page-info {\n  color: #6b7280;\n  font-size: 12px;\n}\n\n.pagination-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.am-prev-next {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.am-page-label {\n  font-size: 13px;\n  color: #374151;\n  white-space: nowrap;\n}\n\n\n/* ===== Drawer backdrop ===== */\n\n.drawer-backdrop {\n  position: fixed;\n  z-index: 8999;\n  inset: 0;\n  background: rgba(0, 0, 0, 0);\n  pointer-events: none;\n  transition: background 0.3s ease;\n}\n\n.drawer-backdrop.backdrop-visible {\n  background: rgba(0, 0, 0, 0.38);\n  pointer-events: all;\n}\n\n\n/* ===== Edit drawer ===== */\n\n.edit-drawer {\n  position: fixed;\n  z-index: 9000;\n  top: 0;\n  right: 0;\n  display: flex;\n  width: 460px;\n  max-width: 95vw;\n  height: 100vh;\n  flex-direction: column;\n  background: #ffffff;\n  box-shadow: -6px 0 32px rgba(0, 0, 0, 0.14);\n  transform: translateX(100%);\n  transition:\n    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.edit-drawer.drawer-open {\n  transform: translateX(0);\n}\n\n\n/* ===== Drawer header ===== */\n\n.drawer-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.drawer-title {\n  color: #141414;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n.drawer-subtitle {\n  margin-top: 3px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.drawer-close-btn {\n  flex-shrink: 0;\n  margin-left: 8px;\n  padding: 2px 6px;\n  border: none;\n  border-radius: 4px;\n  background: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  transition:\n    color 0.15s,\n    background 0.15s;\n}\n\n.drawer-close-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #141414;\n}\n\n.drawer-close-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n\n/* ===== Drawer body ===== */\n\n.drawer-body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.drawer-info-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #f8fafc;\n}\n\n/* ===== Add form ===== */\n.add-form-card {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px 24px;\n  background: #ffffff;\n  border: 1px solid #dde3ea;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 36, 61, 0.08);\n}\n\n.add-form-section-title {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: #00243d;\n}\n\n.add-form-divider {\n  border: none;\n  border-top: 1px solid #e8ecf0;\n  margin: 2px 0;\n}\n\n.add-form-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.drawer-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 32px;\n  gap: 8px;\n  padding: 2px 0;\n}\n\n.drawer-info-row.row-editing {\n  align-items: center;\n}\n\n.info-label {\n  flex-shrink: 0;\n  min-width: 130px;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.info-value-group {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 0;\n  gap: 6px;\n}\n\n.info-value {\n  flex: 1;\n  color: #1a1a1a;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: right;\n  word-break: break-word;\n}\n\n.info-value.value-changed {\n  color: #0073cf;\n  font-weight: 600;\n}\n\n.changed-badge {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 5px;\n  border: 1px solid #bfdbfe;\n  border-radius: 4px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n\n/* ===== Pencil button ===== */\n\n.pencil-btn {\n  flex-shrink: 0;\n  padding: 2px 4px;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  background: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1;\n  transition:\n    color 0.15s,\n    background 0.15s,\n    border-color 0.15s;\n}\n\n.pencil-btn:hover {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  color: #0073cf;\n}\n\n\n/* ===== Inline editing ===== */\n\n.inline-edit-group {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.inline-field-input {\n  flex: 1;\n  max-width: 220px;\n  padding: 6px 8px;\n  border: 1.5px solid #0073cf;\n  border-radius: 4px;\n  outline: none;\n  background: #ffffff;\n  color: #1a1a1a;\n  font-family: inherit;\n  font-size: 13px;\n  box-shadow:\n    0 0 0 3px rgba(0, 115, 207, 0.12);\n}\n\n.inline-field-input:focus {\n  border-color: #005ba4;\n}\n\n.inline-done-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border: none;\n  border-radius: 4px;\n  background: #0073cf;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.15s;\n}\n\n.inline-done-btn:hover {\n  background: #005ba4;\n}\n\n\n/* ===== Messages ===== */\n\n.drawer-error {\n  padding: 10px 14px;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n.drawer-success {\n  padding: 10px 14px;\n  border: 1px solid #86efac;\n  border-radius: 6px;\n  background: #f0fdf4;\n  color: #15803d;\n  font-size: 13px;\n}\n\n\n/* ===== Drawer footer ===== */\n\n.drawer-footer {\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n\n/* ===== History button ===== */\n\n.matrix-history-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: #64a2c8;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.matrix-history-btn:hover {\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  color: #0073cf;\n}\n\n\n\n/* ===== History table ===== */\n\n.history-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 40px 0;\n}\n\n.history-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 48px 0;\n  color: #94a3b8;\n  font-size: 14px;\n  text-align: center;\n}\n\n.history-empty p {\n  margin: 0;\n}\n\n\n.history-table-wrapper {\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: 400px;\n  border: 1px solid #e2e8f0;\n  border-radius: 7px;\n}\n\n.history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.history-table thead tr {\n  background: #f5f7fa;\n  border-bottom: 2px solid #e0e4ea;\n}\n\n.history-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.history-table th {\n  padding: 10px 14px;\n  color: #374151;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.history-table tbody tr {\n  border-bottom: 1px solid #f1f4f8;\n  transition: background 0.1s;\n}\n\n.history-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.history-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.history-table td {\n  padding: 10px 14px;\n  vertical-align: middle;\n  color: #1a1a1a;\n}\n\n.history-td-num {\n  color: #94a3b8;\n  font-size: 12px;\n  text-align: center;\n  width: 32px;\n}\n\n.history-td-old {\n  color: #b91c1c;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.history-td-new {\n  color: #15803d;\n  font-weight: 600;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.history-td-by {\n  color: #374151;\n  white-space: nowrap;\n}\n\n.history-td-dt {\n  color: #64748b;\n  white-space: nowrap;\n  font-size: 12px;\n}\n\n.history-empty-val {\n  color: #94a3b8;\n  font-style: italic;\n  font-weight: 400;\n}\n\n.history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 4px 4px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.history-page-info {\n  color: #64748b;\n  font-size: 13px;\n}\n\n.history-page-btns {\n  display: flex;\n  gap: 8px;\n}\n\n.history-page-btn {\n  padding: 5px 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #374151;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.history-page-btn:hover:not(:disabled) {\n  border-color: #0073cf;\n  background: #eff6ff;\n  color: #0073cf;\n}\n\n.history-page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.history-type-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  white-space: nowrap;\n}\n\n.history-type-badge.individual {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.history-type-badge.bulk {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.history-field-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: capitalize;\n}\n\n.cancel-changes-btn,\n.save-changes-btn,\n.delete-confirm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 8px 18px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.cancel-changes-btn {\n  border: 1px solid #9ca3af;\n  background: #ffffff;\n  color: #1f2937;\n}\n\n.cancel-changes-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.save-changes-btn {\n  border: 1px solid #0073cf;\n  background: #0073cf;\n  color: #ffffff;\n}\n\n.save-changes-btn:hover:not(:disabled) {\n  border-color: #005ba4;\n  background: #005ba4;\n}\n\n.delete-confirm-btn {\n  border: 1px solid #c62828;\n  background: #c62828;\n  color: #ffffff;\n}\n\n.delete-confirm-btn:hover:not(:disabled) {\n  border-color: #991b1b;\n  background: #991b1b;\n}\n\n.cancel-changes-btn:focus,\n.save-changes-btn:focus,\n.delete-confirm-btn:focus {\n  outline: 2px solid #0073cf;\n  outline-offset: 2px;\n}\n\n.cancel-changes-btn:disabled,\n.save-changes-btn:disabled,\n.delete-confirm-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n\n/* ===== Delete dialog ===== */\n\n.delete-overlay {\n  position: fixed;\n  z-index: 9100;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.delete-dialog {\n  display: flex;\n  width: 100%;\n  max-width: 400px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 32px 28px 24px;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow:\n    0 20px 60px rgba(0, 0, 0, 0.25);\n  text-align: center;\n}\n\n.delete-dialog-icon {\n  margin-bottom: 4px;\n  line-height: 1;\n}\n\n.delete-dialog-title {\n  color: #141414;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.delete-dialog-msg {\n  color: #4b5563;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.delete-dialog-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.delete-error {\n  width: 100%;\n  margin-top: 8px;\n}\n\n\n/* ===== Responsive layout ===== */\n\n@media (max-width: 768px) {\n  .content-wrapper {\n    padding: 18px 14px;\n  }\n\n  .pagination-section {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .pagination-controls {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .edit-drawer {\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .drawer-header,\n  .drawer-body,\n  .drawer-footer {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .drawer-info-row {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .info-label {\n    min-width: 0;\n  }\n\n  .info-value-group,\n  .inline-edit-group {\n    width: 100%;\n  }\n\n  .info-value {\n    text-align: left;\n  }\n\n  .inline-field-input {\n    max-width: none;\n  }\n}\n\n\n/* ===== Search bar ===== */\n\n.am-search-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.am-search-badge {\n  padding: 4px 10px;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 13px;\n}\n\n.am-search-badge-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.am-search-error {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n\n/* ===== Select-all row ===== */\n\n.am-select-all-row {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 16px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #f8fafc;\n}\n\n.am-select-all-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #374151;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  user-select: none;\n}\n\n.am-select-all-label input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: #0073cf;\n}\n\n.am-selected-count {\n  padding: 2px 10px;\n  border-radius: 12px;\n  background: #0073cf;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n\n/* ===== Row checkbox in table ===== */\n\n.row-checkbox {\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: #0073cf;\n  vertical-align: middle;\n}\n\n\n/* ===== Bulk update result summary ===== */\n\n.bulk-result-summary {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  gap: 8px;\n  padding: 14px 18px;\n  border: 1px solid #86efac;\n  border-radius: 8px;\n  background: #f0fdf4;\n}\n\n.bulk-result-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.bulk-result-title {\n  color: #15803d;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.bulk-result-dismiss {\n  padding: 0 4px;\n  border: none;\n  border-radius: 4px;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  transition: color 0.15s;\n}\n\n.bulk-result-dismiss:hover {\n  color: #111827;\n}\n\n.bulk-result-counts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.bulk-count {\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bulk-count.success {\n  background: #bbf7d0;\n  color: #14532d;\n}\n\n.bulk-count.error {\n  background: #fecaca;\n  color: #7f1d1d;\n}\n\n.bulk-count.skipped {\n  background: #fef9c3;\n  color: #713f12;\n}\n\n.bulk-result-row {\n  padding: 4px 0;\n  border-top: 1px solid #d1fae5;\n  color: #374151;\n  font-size: 13px;\n}\n\n.bulk-row-status {\n  display: inline-block;\n  margin-right: 8px;\n  padding: 1px 7px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.bulk-row-status.error {\n  background: #fecaca;\n  color: #7f1d1d;\n}\n\n.bulk-row-status.skipped {\n  background: #fef9c3;\n  color: #713f12;\n}\n\n\n/* ===== Bulk edit drawer body ===== */\n\n.bulk-edit-hint {\n  margin: 0 0 4px;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.bulk-field-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.bulk-field-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #f8fafc;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.bulk-field-item:has(input[type=\"checkbox\"]:checked) {\n  border-color: #93c5fd;\n  background: #eff6ff;\n}\n\n.bulk-field-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.bulk-field-toggle input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #0073cf;\n}\n\n.bulk-field-label {\n  color: #1a1a1a;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.bulk-field-input {\n  width: 100%;\n  padding: 7px 10px;\n  border: 1.5px solid #0073cf;\n  border-radius: 4px;\n  outline: none;\n  background: #ffffff;\n  color: #1a1a1a;\n  font-family: inherit;\n  font-size: 13px;\n  box-shadow: 0 0 0 3px rgba(0, 115, 207, 0.1);\n  transition: border-color 0.15s;\n}\n\n.bulk-field-input:focus {\n  border-color: #005ba4;\n  box-shadow: 0 0 0 3px rgba(0, 115, 207, 0.2);\n}\n\n\n/* ===== Bulk edit — current value hint ===== */\n\n.bulk-current-value {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bulk-current-prefix {\n  flex-shrink: 0;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.bulk-current-text {\n  color: #1a1a1a;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.bulk-current-text em {\n  color: #94a3b8;\n  font-style: normal;\n}\n\n.bulk-current-select {\n  flex: 1;\n  min-width: 0;\n  height: 28px;\n  padding: 0 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #1a1a1a;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: default;\n  outline: none;\n  appearance: auto;\n}\n\n.bulk-current-select:disabled {\n  background: #f8fafc;\n  color: #334155;\n  border-color: #e2e8f0;\n  opacity: 1;\n}\n\n.bulk-varies-badge {\n  flex-shrink: 0;\n  padding: 1px 7px;\n  border-radius: 10px;\n  background: #fef3c7;\n  color: #92400e;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  border: 1px solid #fcd34d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
